// crewbit-admin/src/components/money/bootstrap/ProvincePicker.tsx
//
// Tier 2-UI Phase A §WorldClass.4 — admin parallel of mobile ProvincePicker.
// Web idiom: native <select> with 13 options matching `provincial_hst_rates`
// substrate (Migration 272). Hardcoded English per admin convention; queued
// `§Settings.AdminI18nMigration`. Mirrors mobile body decisions per
// `feedback_admin_pair_must_match_mobile_body`.

import { palette, radii, spacing } from '../../../styles/tokens';
import { PROVINCE_LABELS } from '../../../lib/industryToTradeKey';

export type ProvinceCode =
  | 'AB' | 'BC' | 'MB' | 'NB' | 'NL' | 'NS' | 'NT' | 'NU' | 'ON' | 'PE' | 'QC' | 'SK' | 'YT';

const PROVINCE_ORDER: ProvinceCode[] = [
  'AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT',
];

interface Props {
  value: ProvinceCode | null;
  onChange: (next: ProvinceCode) => void;
  error?: string | null;
  disabled?: boolean;
}

export default function ProvincePicker({ value, onChange, error, disabled }: Props) {
  return (
    <div>
      <select
        value={value ?? ''}
        onChange={(e) => {
          const v = e.target.value as ProvinceCode | '';
          if (v) onChange(v);
        }}
        disabled={disabled}
        aria-label="Province"
        style={{
          width: '100%',
          height: 40,
          paddingInline: spacing.md,
          borderRadius: radii.md,
          border: `1px solid ${error ? palette.red : palette.g300}`,
          background: palette.white,
          color: value ? palette.g800 : palette.g500,
          fontSize: 14,
          fontFamily: 'inherit',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <option value="" disabled>
          Pick your province
        </option>
        {PROVINCE_ORDER.map((code) => (
          <option key={code} value={code}>
            {PROVINCE_LABELS[code]}
          </option>
        ))}
      </select>
      {error ? (
        <div style={{ marginTop: spacing.xs, color: palette.red, fontSize: 12 }}>
          {error}
        </div>
      ) : null}
    </div>
  );
}
